import { GrFormClose } from 'react-icons/gr'
import { Container, WarningContainer } from './styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import { useAsyncFn } from 'react-use'
import { learningApi } from '../../../../services/api'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { IFiltersParams } from '../../../../pages/SearchQuestions/components/SearchQuestionsContent/types'
import Loader from '../../../../assets/icons/loader'
import history from '../../../../services/history'
import { IoAlertCircle } from 'react-icons/io5'
import { setState } from '../../../../types/setState'
import Modal from 'pages/MyQuestionBooks/components/Modal'

interface IProps {
  isOpen: boolean
  onClose(): void

  setTracking: setState
  filtersParams: IFiltersParams
  totalQuestions: number
  mostRecent: boolean
}

const CreateQuestionBookModal = (props: IProps) => {
  const { token, profile } = useSelector((state: RootState) => ({
    token: state.auth.token,
    profile: state.student.profile,
  }))

  const [text, setText] = useState('')

  const [state, execute] = useAsyncFn(async () => {
    try {
      const result = await learningApi.post(
        '/question/books',
        {
          student: {
            _id: profile._id,
            name: profile.name,
            email: profile.email,
          },
          name: text,
          filters: { ...props.filtersParams, mostRecent: props.mostRecent },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      props.setTracking((prev) => ({
        event: 'CreateQuestionBook',
        properties: {
          ...prev.properties,
          Questoes_Encontradas: props.totalQuestions,
          Questoes_Caderno: props.totalQuestions > 1000 ? 1000 : props.totalQuestions,
          Status: 'Sucesso',
          Caderno_Nome: text,
          Caderno_Id: result.data.bookId,
        },
      }))

      toast.success('Caderno criado com sucesso!')
      history.push(`/questoes/caderno/${result.data.bookId}`)
    } catch {
      props.setTracking((prev) => ({
        event: 'CreateQuestionBook',
        properties: {
          ...prev.properties,
          Questoes_Encontradas: props.totalQuestions,
          Questoes_Caderno: props.totalQuestions > 1000 ? 1000 : props.totalQuestions,
          Status: 'Falha',
          Caderno_Nome: text,
        },
      }))
      toast.error('Erro ao criar caderno')
    }
  }, [token, text, props.filtersParams, props.mostRecent])

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Container>
        <button className="close" onClick={props.onClose}>
          <GrFormClose size="100%" />
        </button>

        <p className="title">Criar caderno de questões</p>

        <p className="description">Digite o nome do seu caderno</p>

        <div className="input-group">
          <input
            type="text"
            className="text-input"
            placeholder="Nome do caderno"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <button
            className="save"
            disabled={text.length === 0 || state.loading}
            data-loading={state.loading}
            onClick={execute}
          >
            {state.loading ? <Loader className="loader" /> : 'Criar caderno'}
          </button>
        </div>

        <p className="current-name">
          Total de questões: {new Intl.NumberFormat('pt-BR').format(props.totalQuestions || 0)}
        </p>
        {props.totalQuestions > 1000 ? (
          <WarningContainer>
            <IoAlertCircle size={22} />
            <p>O caderno será criado somente com as 1.000 primeiras questões.</p>
          </WarningContainer>
        ) : null}
      </Container>
    </Modal>
  )
}

export default CreateQuestionBookModal
